import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';

const TotalResponses = ({totalResponses, source, onClick}) => {

  const renderText = () => {

    if (source === 'event') {
      if (totalResponses === 1) {
        return 'resultaat';
      } else {
        return 'resultaten';
      }
    }

    if (source === 'questionnaire' || !source) {
        if (totalResponses === 1) {
          return 'antwoord';
        } else {
          return 'antwoorden';
    }
    }
  }

  return (
    <div
      className={`graph-total-responses-container${onClick ? ' graph-total-responses-clickable' : ''}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
    >
        <Groups2OutlinedIcon />
        <p>{totalResponses || 0} {renderText()}</p>
    </div>
  )
}

export default TotalResponses
